import { render, staticRenderFns } from "./CResendVerification.vue?vue&type=template&id=679c04e0&scoped=true&"
import script from "./CResendVerification.vue?vue&type=script&lang=js&"
export * from "./CResendVerification.vue?vue&type=script&lang=js&"
import style0 from "./CResendVerification.vue?vue&type=style&index=0&id=679c04e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c04e0",
  null
  
)

export default component.exports